import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchProjects as fetchProjectsAPI } from '../../services/projectService';
import { deleteProjectAPI } from '../../apis/Projects';

// Async thunk with optional limit parameter
export const fetchProjects = createAsyncThunk(
  'projects/fetchProjects',
  async (limit = null, { rejectWithValue }) => {
    try {
      const data = await fetchProjectsAPI(limit);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteProjectThunk = createAsyncThunk(
  'projects/deleteProject',
  async (projectId, { rejectWithValue }) => {
    try {
      await deleteProjectAPI(projectId);
      return projectId;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const projectSlice = createSlice({
  name: 'projects',
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {
    addProject: (state, action) => {
      state.list.push(action.payload);
    },
    deleteProject: (state, action) => {
      state.list = state.list.filter((p) => p.project_id !== action.payload);
    },
    resetProjects: (state) => {
      state.list = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjects.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchProjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteProjectThunk.fulfilled, (state, action) => {
        state.list = state.list.filter((p) => p.project_id !== action.payload);
      })
      .addCase(deleteProjectThunk.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { addProject, deleteProject, resetProjects } =
  projectSlice.actions;
export default projectSlice.reducer;
